module.exports = __webpack_public_path__ + "img/active-8.afb51133.svg";